// extracted by mini-css-extract-plugin
export var Section = "Partners-module--Section--Z75Cg";
export var Items = "Partners-module--Items--s2zTS";
export var Item = "Partners-module--Item--0eEEc";
export var ItemImage = "Partners-module--ItemImage--orl6D";
export var ItemContent = "Partners-module--ItemContent--CdHWR";
export var ItemName = "Partners-module--ItemName--D23A7";
export var ItemText = "Partners-module--ItemText--TQypf";
export var arrowLeft = "Partners-module--arrowLeft--qa2t5";
export var arrowRight = "Partners-module--arrowRight--E476I";